'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var childrenOf = {};

exports.__exports = childrenOf;
